<template>
  <div class="content-i">
    <div class="content-box">
      <div class="element-wrapper" v-if="!emptyRow">
        <div v-if="customerInfo">
          <h6 class="element-header">{{ t('customerViewCustomerInfoHeader', 'customerViewCustomerInfoHeader') }} {{ customerInfo.reference }}</h6>
          <div class="element-box">
            <div class="element-info mb-4">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-info">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ customerInfo.name }}</h5>
                      <div class="element-inner-desc">{{ customerInfo.reference }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin: 0px;">
              <div class="col-12 mb-2">
                <button class="btn btn-secondary" @click="goBack()">< {{ t('backButtonText', 'backButtonText') }}</button>
              </div>
              <form class="row col-12" v-on:submit.prevent="updateCustomerInfo" style="margin: 0px;">
                <div class="col-3">
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewRefLabel', 'customerViewRefLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <span class="form-control disabled-field">{{ customerInfo.reference }}</span>
                    </div>
                  </div>
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewNameLabel', 'customerViewNameLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <input class="form-control" :placeholder="t('customerViewNameLabel', 'customerViewNameLabel')" type="text" v-model="customerInfo.name">
                    </div>
                  </div>
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewContactNameLabel', 'customerViewContactNameLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <input class="form-control" :placeholder="t('customerViewContactNameLabel', 'customerViewContactNameLabel')" type="text" v-model="customerInfo.contact_name">
                    </div>
                  </div>
                  <div class="row input-row">
                    <!-- EIPP-461 Added email input, PW -->
                    <div class="col-6">
                      <span>{{ t('customerViewPrimaryEmailLabel', 'customerViewPrimaryEmailLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <input class="form-control" :placeholder="t('customerViewPrimaryEmailLabel', 'customerViewPrimaryEmailLabel')" type="text" v-model="customerInfo.client_email">
                    </div>
                  </div>
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewPhone1Label', 'customerViewPhone1Label') }}</span>
                    </div>
                    <div class="col-6">
                      <input class="form-control" :placeholder="t('customerViewPhone1Label', 'customerViewPhone1Label')" type="text" v-model="customerInfo.telephone">
                    </div>
                  </div>
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewPhone2Label', 'customerViewPhone2Label') }}</span>
                    </div>
                    <div class="col-6">
                      <input class="form-control" :placeholder="t('customerViewPhone2Label', 'customerViewPhone2Label')" type="text" v-model="customerInfo.telephone2">
                    </div>
                  </div>
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewFaxNumberLabel', 'customerViewFaxNumberLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <input class="form-control" :placeholder="t('customerViewFaxNumberLabel', 'customerViewFaxNumberLabel')" type="text" v-model="customerInfo.fax">
                    </div>
                  </div>
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewLanguageLabel', 'customerViewLanguageLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <select v-if="!languageDisabled" v-model="customerInfo.language" class="form-control">
                        <option value="" disabled>{{ t('customerViewSelectLanguage', 'customerViewSelectLanguage') }}</option>
                        <option v-for="language in languageList" :key="language.id" :value="language.id">{{ language.name }}</option>
                      </select>
                      <span v-else class="form-control disabled-field">{{ customerInfo.language }}</span>
                    </div>
                  </div>
                  <div class="row input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewCountryLabel', 'customerViewCountryLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <select v-model="customerInfo.country" class="form-control" v-if="!countryDisabled">
                        <option value="" disabled>{{ t('customerViewSelectCountry', 'customerViewSelectCountry') }}</option>
                        <option v-for="country in countryList" :key="country.id" :value="country.id">
                          <template v-if="country.name == 'UK'">
                            United Kingdom
                          </template>
                          <template v-else>
                            {{ country.name }}
                          </template>
                        </option>
                      </select>
                      <span v-else class="form-control disabled-field">{{ customerInfo.country }}</span>
                    </div>
                  </div>
                  <div class="row input-row" v-if="getUserLevel >= 2.00 && isChainFinanceEnabled == 1">
                    <div class="col-6">
                      <span>{{ t('customerViewSupplyChainFinanceLabel', 'customerViewSupplyChainFinanceLabel') }}</span>
                    </div>
                    <!-- Netsend-8, Checkbox had to be changed to read-only, PW -->
                    <!--<div class="col-6">
                    <b-form-checkbox
                      id="chainFinanceCheckbox"
                      v-model="customerInfo.enable_supply_chain_finance"
                      name="chainFinanceCheckbox"
                      value=1
                      unchecked-value=0
                      disabled
                    >
                    </b-form-checkbox>-->
                    <div class="col-6">
                      <!-- EIPP-58 Change displayed statuses based on parent/child customer, PW -->
                      <span v-if="customerInfo.enable_supply_chain_finance == 0">{{ t('eippCustomerText', 'eippCustomerText') }}</span>
                      <span v-if="customerInfo.enable_supply_chain_finance == 1">{{ t('arErroredText', 'arErroredText') }}</span>
                      <span v-if="customerInfo.enable_supply_chain_finance == 2">{{ t('arCandidateText', 'arCandidateText') }}</span>
                      
                      <template v-if="!customerInfo.parent_account_id">
                        <span v-if="customerInfo.enable_supply_chain_finance == 3">{{ t('arRequestSentText', 'arRequestSentText') }}</span>
                        <span v-if="customerInfo.enable_supply_chain_finance == 4">{{ t('arCustomerText', 'arCustomerText') }}</span>
                      </template>
                      <template v-else-if="customerInfo.parent_account_id">
                        <span v-if="customerInfo.enable_supply_chain_finance == 3">{{ t('eippAwaitingParentEnrollment', 'eippAwaitingParentEnrollment') }}</span>
                        <span v-if="customerInfo.enable_supply_chain_finance == 4">{{ t('arCustomerText', 'arCustomerText') }}</span>
                      </template>
                      
                    </div>
                  </div>
                  <div class="row input-row" v-if="getUserLevel >= 2.00 && isChainFinanceEnabled == 1">
                    <div class="col-6">
                      <span>{{ $t('managerARParentCustomerLabel', 'managerARParentCustomerLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <template v-if="customerInfo.parentCustomerRef && customerInfo.parent_account_id">
                        <span class="font-weight-bold text-primary parent-customer-text" @click="goToParentCustomer(customerInfo.parent_account_id)">
                          {{ customerInfo.parentCustomerRef }}
                        </span>
                      </template>
                      <template v-else>
                        <span>{{ t('notAvailableText', 'notAvailableText') }}</span>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row right-block-input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewAddressLabel', 'customerViewAddressLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <textarea class="log-textbox text-muted" rows="8" cols="40" v-model="customerInfo.postal_address" :readonly="addressReadOnly"></textarea>
                    </div>
                  </div>
                  <div class="row right-block-input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewPostcodeLabel', 'customerViewPostcodeLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <input class="form-control" :placeholder="t('customerViewPostcodeLabel', 'customerViewPostcodeLabel')" type="text" v-model="customerInfo.postcode">
                    </div>
                  </div>
                  <div class="row right-block-input-row" v-if="allTemplateDetails && allTemplateDetails.use_customer_principles">
                    <div class="col-6">
                      <span>{{ t('customerViewPrincipalLabel', 'customerViewPrincipalLabel') }}</span>
                    </div>
                    <div class="col-6">
                      <select v-model="customerInfo.principle" class="form-control mt-2" v-if="userCanSetPrincipals">
                        <option value="" disabled>{{ t('customerViewSelectPrincipal', 'customerViewSelectPrincipal') }}</option>
                        <option v-for="principle in principleList" :key="principle.id" :value="principle.id">{{ principle.name }}</option>
                      </select>
                      <span v-else class="form-control disabled-field">{{ customerInfo.principleName }}</span>
                    </div>
                  </div>
                  <div v-if="showFIO" class="row right-block-input-row">
                    <div class="col-6">
                      <span>{{ t('customerViewFIO', 'customerViewFIO') }}</span>
                    </div>
                    <div class="col-6">
                      <select v-model="customerInfo.fio_watermark" class="form-control mt-2">
                        <option v-for="fioWatermark in fioWatermarks" :key="fioWatermark.id" :value="fioWatermark.id">{{ fioWatermark.status }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row right-block-input-row" v-if="showMaxNumEmailAttachments">
                    <div class="col-6 mt-2">
                      <span>{{ t('customerViewMaxEmailLabel', 'customerViewMaxEmailLabel') }}: </span>
                    </div>
                    <div class="col-6 mt-2 text-left">
                      <input v-model="customerInfo.max_num_email_attachements" class="form-control text-center mr-2" type="text" style="width: 50px; display: inline;">
                      <span>{{ t('customerViewMaxEmailDetail', 'customerViewMaxEmailDetail') }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-12 mt-3 p-0" v-if="showCustomerEmailSettings">
                  <div class="col-12">
                    <span style="font-size: 16px;">{{ t('customerViewEmailSubjectOverride', 'customerViewEmailSubjectOverride') }}</span>
                  </div>
                  <div class="col-6 mt-2">
                    <span>{{ t('customerViewEmailSubjectLine', 'customerViewEmailSubjectLine') }}:</span>
                  </div>
                  <div class="col-12">
                    <input type="text" v-model="customerInfo.force_email_subject_line"/> <br>
                    <small>{{ t('customerViewEmailSubjectDetails', 'customerViewEmailSubjectDetails') }}</small>
                  </div>
                </div>
                <ResponseInfo v-if="getResponseInfo.responseName == 'customerDetails'"></ResponseInfo>
                <div class="col-12 mt-2" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
                  <button type="submit" class="btn btn-primary mt-2">{{ t('saveButtonLabel', 'saveButtonLabel') }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="element-wrapper" v-else>
        <div class="col-12 text-center">
          {{ t('customerViewCustomerNotFound', 'customerViewCustomerNotFound') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'CustomerView',
  components: {
    ResponseInfo
  },
  data() {
    return {
      customerId: this.$route.params.id,
      customer: null,
      customerInfo: null,
      countryList: null,
      principleList: null,
      userCanSetPrincipals: false,
      addressReadOnly: false,
      countryDisabled: false,
      languageDisabled: false,
      showMaxNumEmailAttachments: false,
      showFIO: false,
      showCustomerEmailSettings: false,
      isChainFinanceEnabled: 0,
      emptyRow: false,
      fioWatermarks: []
    }
  },
  created() {
    if(!this.$route.params.id || this.$route.params.id == 0 || this.$route.params.id < 0) {
      this.$router.push({ name: 'manage_customers' })
    } else {
      this.requestCustomerInformation()
    }
  },
  methods: {
    requestCustomerInformation() {
      this.$store.dispatch('manageCustomersStore/getCustomerInformation', this.customerId).then(data => {
        this.customerInfo = data.customerInfo
        this.languageList = data.languageList
        this.countryList = data.countryList
        this.principleList = data.principleList
        this.userCanSetPrincipals = data.userCanSetPrincipals
        this.addressReadOnly = data.addressReadOnly
        this.countryDisabled = data.countryDisabled
        this.languageDisabled = data.languageDisabled
        this.showMaxNumEmailAttachments = data.showMaxNumEmailAttachments
        this.showFIO = data.showFIO
        this.showCustomerEmailSettings = data.showCustomerEmailSettings
        this.isChainFinanceEnabled = data.isChainFinanceEnabled
        if(data.fioWatermarks) {
          this.fioWatermarks = data.fioWatermarks
        }
        if(this.customerInfo === undefined || this.customerInfo.length === 0) {
          this.emptyRow = true
        } else {
          if(data.customerInfo) {
            // NS-10611 Default language and country if not set, PW
            if(!data.customerInfo.language) {
              let langIndex = null
              langIndex = data.languageList.findIndex(x => x.name === "English");

              if(langIndex) {
                this.customerInfo.language = data.languageList[langIndex].id
              } else {
                this.customerInfo.language = ''
              }
            }

            if(!data.customerInfo.country) {
              let countIndex = null
              countIndex = data.countryList.findIndex(x => x.name === "UK");

              if(countIndex) {
                this.customerInfo.country = data.countryList[countIndex].id
              } else {
                this.customerInfo.country = ''
              }
            }
          }
          this.emptyRow = false
        }
      })      
    },
    goToParentCustomer(custId) {
      this.customerId = custId
      this.$router.push({ name: 'customer_view', params: { id: custId } })
      this.requestCustomerInformation()
      this.$forceUpdate();
    },
    updateCustomerInfo() {
      //this.$router.push({ name: 'manage_customers' })
      this.$store.dispatch('manageCustomersStore/updateCustomerInformation', this.customerInfo)
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo', 'getIsNewsnet', 'getUserLevel', 'allTemplateDetails'])
  }
}

</script>

<style scoped>
  .disabled-field {
    background-color: rgb(233, 236, 239);
  }
  .input-row {
    align-items: center;
    margin-top: 5px;
  }
  .right-block-input-row {
    align-items: center;
    text-align: right;
    margin-top: 5px;
  }
  .parent-customer-text {
    cursor: pointer;
  }
</style>